import { delay } from 'rxjs/operators';
import { Typetache } from './../../../../models/typetache.model';
import { Role } from './../../../../models/role.model';
import { TabService } from './../../../../services/tab.service';
import { TranslateService } from '@ngx-translate/core';
import { OnInit, Component, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { environment } from '../../../../../environments/environment.prod';
import { TypeTacheService } from '../../../../services/typeTache.service';
import { NbToastRef, NbToastrService } from '@nebular/theme';
import { NB_TOASTR_CONFIG } from '@nebular/theme/components/toastr/toastr-config';

@Component({
  selector: 'app-tabParamTache',
  templateUrl: './tabParamTache.component.html',
  styleUrls: ['./tabParamTache.component.scss'],
})
export class TabParamTacheComponent implements OnInit {
  @Input() typeTaches: Typetache[];
  defaultOrdre: number;
  source: LocalDataSource;
  toastRef: NbToastRef;
  constructor(private toastrService: NbToastrService, private typetacheService: TypeTacheService, private tabService: TabService, private translate: TranslateService) {

  }
  ngOnInit() {
  }

  settings = {
    actions: {
      delete: false,
      add: false,
    },
    edit: {
      editButtonContent: '<i class="nb-edit"></i>',
      saveButtonContent: '<i class="nb-checkmark"></i>',
      cancelButtonContent: '<i class="nb-close"></i>',
      confirmSave: true,
      mode: 'inline',
    },
    columns: {
      typesalle: {
        title: this.translate.instant('ROOM'),
        type: 'string',
        valuePrepareFunction: (value) => {
          value = this.translate.instant('ROOM_' + value.id);
          return value;
        },
        editable: false,
      },
      libelle: {
        title: this.translate.instant('TASK_TYPE'),
        type: 'string',
        editable: false,
      },
      retardAdmissible: {
        title: this.translate.instant('ALLOWED_DELAY'),
        type: 'number',
      },
    },
  };

  onEditConfirm(event): void {
    if (window.confirm(this.translate.instant('TASK_EDIT_CONFIRM'))) {
      this.typetacheService.update_typetache(event.newData)
      .subscribe(response => {
        event.confirm.resolve(event.newData);
        this.toastrService.success(this.translate.instant('TASK_MODIFIED'),
        this.translate.instant('SUCCESS'));
      },
      (err) => {
        err.error.forEach(error => {
          this.toastrService.danger(this.translate.instant('ERROR_' + error.msg),
                                    this.translate.instant('ERROR_INVALID_TYPE'));
        });
      });
    } else {
      event.confirm.reject();
    }
  }



}
